export default __webpack_public_path__ + "static/media/water.d334d546.png";